/* @flow */
import React from 'react';
import { useSelector } from 'react-redux';
import { LiraContainer, Section, TitleH2 } from '../styles';
import { Container } from '../../../components/Layout/styles';
import {
	Activity,
	Chat,
	Filter,
	Document,
	Mortgage,
	Shield,
	Activity2x,
	Document2x,
	Filter2x,
	Chat2x,
	Mortgage2x,
	Shield2x,
} from '../images';
import { BenefitsElement, BenefitsWrapper, TextWrapper, Text } from './styles';
import type { TServices, TServicesWhyItem } from '../../../types/services';

const Benefits = () => {
	const services: TServices = useSelector((state) => state.services);

	const {
		data: { why },
		isLoaded,
	} = services;

	const getIcon = (url) => {
		switch (url) {
			case 'https://cdn.living.ru/systems/living_service/pic/filters.png':
				return {
					icon: Filter,
					icon2x: Filter2x,
				};
			case 'https://cdn.living.ru/systems/living_service/pic/stat.png':
				return {
					icon: Activity,
					icon2x: Activity2x,
				};
			case 'https://cdn.living.ru/systems/living_service/pic/check.png':
				return {
					icon: Mortgage,
					icon2x: Mortgage2x,
				};
			case 'https://cdn.living.ru/systems/living_service/pic/sheild.png':
				return {
					icon: Shield,
					icon2x: Shield2x,
				};
			case 'https://cdn.living.ru/systems/living_service/pic/documents.png':
				return {
					icon: Document,
					icon2x: Document2x,
				};
			case 'https://cdn.living.ru/systems/living_service/pic/chat.png':
				return {
					icon: Chat,
					icon2x: Chat2x,
				};
			default:
				return null;
		}
	};

	if (isLoaded)
		return (
			<Section id="SectionCompare">
				<Container>
					<LiraContainer>
						<TitleH2 isCenter>Технологично и безопасно</TitleH2>
						<BenefitsWrapper>
							{why?.map((item: TServicesWhyItem, idx: number) => (
								<BenefitsElement key={item.title} id={`benefits${idx}`}>
									<img
										alt={item.title}
										src={getIcon(item.icon).icon}
										srcSet={`${getIcon(item.icon).icon2x} 2x`}
									/>
									<TextWrapper>
										<p>
											<b>{item.title}</b>
										</p>
										<Text>{item.description}</Text>
									</TextWrapper>
								</BenefitsElement>
							))}
						</BenefitsWrapper>
					</LiraContainer>
				</Container>
			</Section>
		);
	return null;
};

export default Benefits;
